module.exports = __webpack_public_path__ + "static/media/key-banesco-selected.b55e30db.svg";